
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/[[...slug]]",
      function () {
        return require("private-next-pages/reference/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/[[...slug]]"])
      });
    }
  